import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";

import { useMutation } from "@tanstack/react-query";

import { Plants } from "../../../api/plants";
import { PlantGrowthConditions } from "../../../api/types/plants";
import { MutationKey } from "../../../consts/mutation-keys";
import { QueryKey } from "../../../consts/query-keys";
import { useApiError } from "../../../hooks/useApiError";
import { useApiSuccess } from "../../../hooks/useApiSuccess";
import { ApiHookConfig } from "../../../types/api-hook-config";
import { CafsForm } from "../../../types/cafs-form";

export const useGrowthConditionsUpdate = ({ onSuccess }: ApiHookConfig) => {
  const { datasetId, id } = useParams();
  const { formatMessage } = useIntl();
  const { handleSuccess } = useApiSuccess({
    invalidate: [
      [QueryKey.GrowthConditionsSection],
      [QueryKey.CafsDetails],
      [QueryKey.PlantAudit],
    ],
    snackbarText: formatMessage({
      id: "ACTIONS.GROWTH_CONDITIONS_UPDATE",
      defaultMessage: "Plant growth conditions updated successfully.",
      description: "Plant growth conditions update success message",
    }),
    onSuccessFn: onSuccess,
  });

  const { handleError, apiErrors } = useApiError();

  const mutationFn = (data: Partial<CafsForm<PlantGrowthConditions>>) =>
    Plants.updateGrowthConditions(
      {
        path: { datasetId: +datasetId! as number, plantId: +id! as number },
      },
      data,
    );

  const { mutate: updateGrowthConditions, isPending } = useMutation({
    mutationKey: [MutationKey.SaveGrowthConditionsSection, datasetId, id],
    mutationFn: mutationFn,
    onSuccess: handleSuccess,
    onError: handleError,
  });

  return { updateGrowthConditions, apiErrors, isPending };
};
